import { SendEmailDto, SendEmailResponseDto } from '../interfaces/email';
import { request } from './Request';


class EmailService {
    private readonly baseEndpoint = '/mail/send';

    async sendEmail(payload: SendEmailDto): Promise<SendEmailResponseDto> {
        try {
            const response = await request.post<SendEmailResponseDto>(
                `${this.baseEndpoint}`,
                payload
            );

            return response.data;
        } catch (error) {

            throw new Error('No se pudo enviar el correo electrónico de activación');
        }
    }

}
export const emailService = new EmailService();
export default EmailService;